export enum enumMimeType {
  AAC = 'audio	audio/aac',
  ABW = 'application/x-abiword',
  ARC = 'application/x-freearc',
  AVI = 'video/x-msvideo',
  AZW = 'application/vnd.amazon.ebook',
  BIN = 'application/octet-stream',
  BMP = 'image/bmp',
  BZ = 'application/x-bzip',
  BZ2 = 'application/x-bzip2',
  CSH = 'application/x-csh',
  CSS = 'text/css',
  CSV = 'text/csv',
  DOC = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  EOT = 'application/vnd.ms-fontobject',
  EPUT = 'application/epub+zip',
  GZ = 'application/gzip',
  GIF = 'image/gif',
  HTM = 'text/html',
  HTML = 'text/html',
  ICO = 'image/vnd.microsoft.icon',
  ICS = 'text/calendar',
  JAR = 'application/java-archive',
  JPG = 'image/jpeg',
  JPEG = 'image/jpeg',
  JS = 'text/javascript',
  JSON = 'application/json',
  JSONLD = 'application/ld+json',
  MIDI = 'audio/midi',
  X_MIDI = 'audio/x-midi',
  MP3 = 'audio/mpeg',
  MPEG = 'video/mpeg',
  MPKG = 'application/vnd.apple.installer+xml',
  ODP = 'application/vnd.oasis.opendocument.presentation',
  ODS = 'application/vnd.oasis.opendocument.spreadsheet',
  ODT = 'application/vnd.oasis.opendocument.text',
  OGA = 'audio/ogg',
  OGV = 'video/ogg',
  OGX = 'application/ogg',
  OPUS = 'audio/opus',
  OTF = 'font	font/otf',
  PNG = 'image/png',
  PDF = 'application/pdf',
  PHP = 'application/x-httpd-php',
  PPT = 'application/vnd.ms-powerpoint',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  RAR = 'application/vnd.rar',
  RTF = 'application/rtf',
  SH = 'application/x-sh',
  SVG = 'image/svg+xml',
  SWF = 'application/x-shockwave-flash',
  TAR = 'application/x-tar',
  TIF = 'image/tiff',
  TIFF = 'image/tiff',
  TS = 'video/mp2t',
  TTF = 'font/ttf',
  TXT = 'text/plain',
  VSD = 'application/vnd.visio',
  WAV = 'audio/wav',
  WEBA = 'audio/webm',
  WEBM = 'video/webm',
  WEBP = 'image/webp',
  WOFF = 'font/woff',
  WOFF2 = 'font/woff2',
  XHTML = 'application/xhtml+xml',
  XLS = 'application/vnd.ms-excel',
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  XML = 'application/xml',
  TEXT_XML = 'text/xml',
  XUL = 'application/vnd.mozilla.xul+xml',
  ZIP = 'application/zip',
  AUDIO_3GP = 'audio/3gpp',
  VIDEO_3GP = 'video/3gpp',
  AUDIO_3GP2 = 'audio/3gpp2',
  VIDEO_3GP2 = 'video/3gpp2',
  X_7Z = 'application/x-7z-compressed', // .7z
  EML = 'message/rfc822',
}
